module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjMyMiIgaGVpZ2h0PSIxNi4zMDUiIHZpZXdCb3g9IjAgMCA5LjMyMiAxNi4zMDUiPgogIDxwYXRoIGlkPSJJY29uX2lvbmljLWlvcy1hcnJvdy1iYWNrIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtaW9zLWFycm93LWJhY2siIGQ9Ik0xNC4wNjEsMTQuMzQ0LDIwLjIzLDguMThhMS4xNjUsMS4xNjUsMCwxLDAtMS42NS0xLjY0NWwtNi45OSw2Ljk4NWExLjE2MywxLjE2MywwLDAsMC0uMDM0LDEuNjA3bDcuMDE5LDcuMDMzYTEuMTY1LDEuMTY1LDAsMSwwLDEuNjUtMS42NDVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMC41NzIgMjIuNDk5KSByb3RhdGUoMTgwKSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/blog/img/icn_next.svg
// module id = LJHr
// module chunks = 0